import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Typography, Grid, Theme } from '@material-ui/core'
import messages from '@utils/messages'
import { makeStyles } from '@material-ui/core/styles'
import ResponsiveModal, { ModalSizes } from '@src/components/ResponsiveModal'
import { ResponsiveModalBody } from '@src/components/ResponsiveModal/ResponsiveModal'

const useStyles = makeStyles((theme: Theme) => ({
  body: {
    paddingBottom: theme.spacing(7),
  },
}))

enum PageInView {
  OrderPage = 'order',
  QuotesPage = 'quotes',
}

const ShowOrderConfirmationDialog = ({
  open,
  handleClose,
  erpSystemId,
  customerIconFlag,
  type,
}) => {
  const classes = useStyles()

  const getMessage = (erpSystemId: string) => {
    if (
      erpSystemId === 'PRP' ||
      erpSystemId === 'QRP' ||
      erpSystemId === 'URP'
    ) {
      return customerIconFlag ? (
        <Grid container spacing={6} className={classes.body}>
          <Grid item xs={12}>
            <FormattedMessage {...messages.CUSTOMER_NUMBER_PRP_DEFINITION} />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={6} className={classes.body}>
          {type === PageInView.OrderPage ? (
            <Grid item xs={12}>
              <FormattedMessage
                {...messages.TRANSACTION_ORDER_PRP_NUMBER_DEFINITION}
              />
            </Grid>
          ) : (
            <Grid item xs={12}>
              <FormattedMessage
                {...messages.TRANSACTION_QUOTE_PRP_NUMBER_DEFINITION}
              />
            </Grid>
          )}
        </Grid>
      )
    } else if (erpSystemId === 'PRD' || erpSystemId === 'STN') {
      return customerIconFlag ? (
        <Grid container spacing={6} className={classes.body}>
          <Grid item xs={12}>
            <FormattedMessage {...messages.CUSTOMER_NUMBER_PRD_DEFINITION} />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={6} className={classes.body}>
          {type === PageInView.OrderPage ? (
            <Grid item xs={12}>
              <FormattedMessage
                {...messages.TRANSACTION_ORDER_PRD_NUMBER_DEFINITION}
              />
            </Grid>
          ) : (
            <Grid item xs={12}>
              <FormattedMessage
                {...messages.TRANSACTION_QUOTE_PRD_NUMBER_DEFINITION}
              />
            </Grid>
          )}
        </Grid>
      )
    } else if (erpSystemId === 'PRE' || erpSystemId === 'Q47') {
      return customerIconFlag ? (
        <Grid container spacing={6} className={classes.body}>
          <Grid item xs={12}>
            <FormattedMessage {...messages.CUSTOMER_NUMBER_PRE_DEFINITION} />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={6} className={classes.body}>
          {type === PageInView.OrderPage ? (
            <Grid item xs={12}>
              <FormattedMessage
                {...messages.TRANSACTION_ORDER_PRE_NUMBER_DEFINITION}
              />
            </Grid>
          ) : (
            <Grid item xs={12}>
              <FormattedMessage
                {...messages.TRANSACTION_QUOTE_PRE_NUMBER_DEFINITION}
              />
            </Grid>
          )}
        </Grid>
      )
    } else {
      return ''
    }
  }

  return (
    <ResponsiveModal
      size={ModalSizes.Small}
      renderTitle={() => (
        <Typography variant="h2" component="h2">
          {customerIconFlag ? (
            <FormattedMessage
              {...messages.CUSTOMER_CONFIRMATION_DIALOG_TITLE}
            />
          ) : (
            <>
              {type === PageInView.OrderPage ? (
                <FormattedMessage
                  id="ORDER_NUMBER"
                  defaultMessage="Order Number"
                />
              ) : (
                <FormattedMessage {...messages.QUOTES_REF_NUMBER} />
              )}
            </>
          )}
        </Typography>
      )}
      open={open}
      onClose={handleClose}
    >
      <ResponsiveModalBody>{getMessage(erpSystemId)}</ResponsiveModalBody>
    </ResponsiveModal>
  )
}

export default ShowOrderConfirmationDialog
